var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAdvanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 31.542,
    height: 35.697,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_advanced",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(338.062 222.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182-2",
    "data-name": "Group 182",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21755",
    "data-name": "Path 21755",
    d: "M24.345,2.08C23.342,0,20.57.08,16.1.464S12.6,5.579,13.374,6c1.717.916,4.384.138,4.384.138a1.576,1.576,0,0,1-.983.562,7.58,7.58,0,0,1-1.684.061c-.165.074-.242.933,1.512,1.455,2.233.667,4.967-1.276,4.967-1.276a35.335,35.335,0,0,1-1.081,7.553,18.25,18.25,0,0,0-.842,3.414A6.168,6.168,0,0,0,15.395,16.3,6.222,6.222,0,0,0,11.246,17.8c-1.165-2.017-4.357-3.465-8.112-3.465a13.678,13.678,0,0,0-2.889.3V34.2a2.979,2.979,0,0,0,.69.084c2.276,0,4.2-2.458,4.886-5.866,1.546,1.967,4.815,3.2,8.6,3.2a13.884,13.884,0,0,0,6.492-1.626c3.111-.677,8.981-2.135,9.206-5.327.293-4.074-4.775-20.5-5.778-22.581",
    transform: "translate(0.58 0.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21756",
    "data-name": "Path 21756",
    d: "M.622,18.288a7.371,7.371,0,0,0,5.209,2.266,9.084,9.084,0,0,0,5.2-1.078,5.081,5.081,0,0,0,5.334,2.781c4.031-.381,4.738-3.465,4.738-3.465s3.2.525,3.448-3.1c.283-4.054-.172-14.412-.172-14.412l3.29,8.7,2.472,11.2L28.689,24.6l-5.172,2.317-3.556,1.1-4.58,1.128H10.02l-4.2-3.162L3.228,30.943l-2.983.818Z",
    transform: "translate(0.58 3.029)",
    fill: "#ffc5c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21757",
    "data-name": "Path 21757",
    d: "M1.519,35.7a3.979,3.979,0,0,1-.879-.1L0,35.448V14.56l.653-.141a14.554,14.554,0,0,1,3.064-.32c3.549,0,6.677,1.2,8.287,3.115a7.166,7.166,0,0,1,3.97-1.152,7.305,7.305,0,0,1,3.684.977c.135-.559.333-1.283.626-2.209a29.12,29.12,0,0,0,.953-5.839,6.289,6.289,0,0,1-4.29.6c-1.744-.519-2.1-1.411-2.165-1.859a4.451,4.451,0,0,1-1.216-.421c-.842-.455-1.317-2.27-1-3.808A4.142,4.142,0,0,1,16.608.229c4.155-.357,7.738-.663,9.062,2.084.939,1.953,6.179,18.557,5.859,23-.253,3.542-5.644,5.149-9.742,6.048A14.714,14.714,0,0,1,15,33.03,13.324,13.324,0,0,1,6.839,30.6c-1,3.1-3.034,5.095-5.32,5.095M1.65,15.911V34.044c1.738-.1,3.344-2.209,3.943-5.2l.354-1.754,1.1,1.408C8.449,30.276,11.5,31.38,15,31.38A12.984,12.984,0,0,0,21.1,29.855l.226-.084c5.549-1.206,8.432-2.744,8.56-4.576.273-3.795-4.623-19.931-5.7-22.167-.711-1.482-2.775-1.552-7.432-1.152a2.592,2.592,0,0,0-2.421,1.492,3.238,3.238,0,0,0,.088,2.526,6.185,6.185,0,0,0,3.7.037l1.967-.566L19.056,7.135a2.268,2.268,0,0,1-1.418.929c1.492.29,3.4-.758,4.037-1.212l1.357-.963-.057,1.663a35.656,35.656,0,0,1-1.118,7.775,17.983,17.983,0,0,0-.808,3.239l-.158,1.69-1.229-1.168a5.374,5.374,0,0,0-3.687-1.377,5.422,5.422,0,0,0-3.6,1.293l-.761.68-.505-.882c-1.037-1.8-4.078-3.054-7.395-3.054a13.456,13.456,0,0,0-2.068.162",
    transform: "translate(0 -0.001)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdvanced);
export default __webpack_public_path__ + "static/media/ic_advanced.2b202a28020f977c7910069ed1702837.svg";
export { ForwardRef as ReactComponent };